/* ELLESANTI V3 · accessibilità · giri A1 e A2 (2/10/2026)
   A1: 4 descrizioni delle immagini · 6 fila delle foto della scheda da tastiera · 8 attributi ARIA.
   A2: 3 bottoni Ferma / Riprendi (nastro dei musei, barra annunci; Instagram senza bottone dal 5/10) · 7 ordine del Tab nel menu · 9 errori collegati ai campi.
   Gira all'avvio e sui contenuti caricati dopo (anteprima rapida, filtri, carrello). Non cambia nulla a schermo. */
(function(){
  var en=(document.documentElement.lang||'').toLowerCase().indexOf('en')===0;
  var T=function(it,e){return en?e:it};
  /* 4 · alt per nome del file, solo nei punti conosciuti. Il nome vero va scritto anche nei File di Shopify. */
  var MAPPE=[
    ['.e-pay',{'rectangle_1':'Stripe','rectangle_3':'Visa','mastercard_2019_logo_1':'Mastercard','group':'Maestro'}],
    ['.e-bmus',{'loghi_musei-01':'Denver Art Museum','loghi_musei-02':'Bottega Brera','loghi_musei-03':'MoMA','loghi_musei-05':'MFA Boston','loghi_musei-06':'New York Public Library','loghi_musei-07':'Mart','loghi_musei-08':'Museo degli Innocenti','loghi_musei-09':'Gallerie Nazionali Barberini Corsini','loghi_musei-10':'MAXXI','loghi_musei-11':'Orchestra di Padova e del Veneto'}],
    ['.e-lab__img,.e-lab__im2',{'emptyname_70':T('Al banco del laboratorio Ellesanti, a Padova','At the bench in the Ellesanti workshop, in Padua'),'rectangle_2_4':T('L’ingresso dello Spazio Ellesanti in Via XX Settembre, a Padova','The entrance of the Ellesanti Space in Via XX Settembre, Padua')}],
    ['.e-pacc__in--img,.e-easy__im',{'emptyname_22_copia':T('La confezione regalo Ellesanti','The Ellesanti gift box')}]
  ];
  function chiave(src){
    var f=(src||'').split('?')[0].split('/').pop().toLowerCase().replace(/\.(png|jpe?g|webp|gif|svg|avif)$/,'');
    return f.replace(/_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/,'');
  }
  function alt(root){
    root.querySelectorAll('img:not([alt])').forEach(function(img){
      if(img.closest('[aria-hidden="true"]')){img.setAttribute('alt','');return}
      var k=chiave(img.getAttribute('src')),v='';
      for(var i=0;i<MAPPE.length;i++){if(img.closest(MAPPE[i][0])&&MAPPE[i][1][k]){v=MAPPE[i][1][k];break}}
      img.setAttribute('alt',v);
    });
    root.querySelectorAll('.e-pay[aria-label]:not([role])').forEach(function(s){s.setAttribute('role','group')});
  }
  /* 6 · la fila delle foto, quando scorre di lato, si raggiunge con il Tab e si scorre con le frecce */
  function galleria(){
    document.querySelectorAll('.e-gal__g').forEach(function(g){
      var scorre=g.scrollWidth>g.clientWidth+2;
      if(scorre&&!g.hasAttribute('tabindex')){g.setAttribute('tabindex','0');g.setAttribute('role','region');g.setAttribute('aria-label',T('Foto del gioiello','Product photos'));g.setAttribute('data-e-a11y','1')}
      else if(!scorre&&g.getAttribute('data-e-a11y')){g.removeAttribute('tabindex');g.removeAttribute('role');g.removeAttribute('aria-label');g.removeAttribute('data-e-a11y')}
    });
  }
  /* 8 · attributi ARIA */
  function aria(root){
    /* carrello: il pannello «CartDrawer» del tema di partenza è spento */
    root.querySelectorAll('[aria-controls="CartDrawer"]').forEach(function(a){if(!document.getElementById('CartDrawer'))a.removeAttribute('aria-controls')});
    /* frecce del feed Instagram senza nome */
    root.querySelectorAll('.gfa-arrow-left:not([aria-label])').forEach(function(x){x.setAttribute('aria-label',T('Foto precedente','Previous photo'))});
    root.querySelectorAll('.gfa-arrow-right:not([aria-label])').forEach(function(x){x.setAttribute('aria-label',T('Foto successiva','Next photo'))});
    /* «Tutte» nelle scorciatoie delle categorie: aria-pressed vale solo per i bottoni */
    root.querySelectorAll('[aria-pressed]').forEach(function(e){
      if(e.tagName==='BUTTON'||e.getAttribute('role')==='button')return;
      if(e.getAttribute('aria-pressed')==='true')e.setAttribute('aria-current','true');
      e.removeAttribute('aria-pressed');
    });
    /* frasi d'ingresso: il testo ricco del campo arriva già con la sua lista, la lista esterna diventa un contenitore */
    root.querySelectorAll('ul').forEach(function(u){
      var c=u.children;if(!c.length)return;
      for(var i=0;i<c.length;i++){if(!c[i].classList.contains('metafield-rich_text_field'))return}
      var d=document.createElement('div');
      for(var j=0;j<u.attributes.length;j++)d.setAttribute(u.attributes[j].name,u.attributes[j].value);
      while(u.firstChild)d.appendChild(u.firstChild);
      u.parentNode.replaceChild(d,u);
    });
    /* frase animata: le lettere restano nascoste ai lettori di schermo, la frase intera si legge da un testo nascosto */
    root.querySelectorAll('[data-e-big][aria-label]').forEach(function(p){
      if(p.querySelector('[aria-hidden="true"]')){
        var s=document.createElement('span');s.className='sr-only';s.textContent=p.getAttribute('aria-label');
        p.insertBefore(s,p.firstChild);
      }
      p.removeAttribute('aria-label');
    });
  }
  /* 9 · errori dei moduli collegati al campo: il lettore di schermo li legge anche tornando sul campo (3.3.1) */
  var nErr=0;
  function errori(root){
    root.querySelectorAll('.e-fld').forEach(function(f){
      var e=f.querySelector('.e-fld__e'),c=f.querySelector('input:not([type=hidden]),select,textarea');
      if(!e||!c)return;
      if(!e.id)e.id='e-err-'+(++nErr);
      var d=(c.getAttribute('aria-describedby')||'').split(' ').filter(Boolean);
      if(d.indexOf(e.id)<0){d.push(e.id);c.setAttribute('aria-describedby',d.join(' '))}
    });
  }

  /* 3 · giro A2 · contenuti che si muovono da soli: bottone Ferma / Riprendi (2.2.2).
     Nastro dei musei (homepage e scheda), feed Instagram, barra degli annunci. Con «riduci movimento» il tema li ferma già. */
  var RM=false;try{RM=matchMedia('(prefers-reduced-motion: reduce)').matches}catch(e){}
  var ICO_P='<svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true" focusable="false"><rect x="2.5" y="2" width="2.2" height="8" fill="currentColor"/><rect x="7.3" y="2" width="2.2" height="8" fill="currentColor"/></svg>';
  var ICO_R='<svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true" focusable="false"><path d="M3 1.8v8.4L10 6z" fill="currentColor"/></svg>';
  function bottone(cls,fermo,riprendi,nome){
    var b=document.createElement('button');b.type='button';b.className='e-a11y-pausa '+cls;b.setAttribute('aria-pressed','false');
    if(nome)b.setAttribute('aria-label',fermo+' '+nome);
    b.innerHTML=ICO_P+'<span>'+fermo+'</span>';
    b._set=function(on){b.setAttribute('aria-pressed',on?'true':'false');b.innerHTML=(on?ICO_R:ICO_P)+'<span>'+(on?riprendi:fermo)+'</span>';if(nome)b.setAttribute('aria-label',(on?riprendi:fermo)+' '+nome)};
    return b;
  }
  function metti(b,dopo,wrap){
    var w=document.createElement('div');w.className='e-a11y-pausa-w'+(wrap&&!(dopo.parentNode.closest&&dopo.parentNode.closest('.e-wrap'))?' e-wrap':'');
    w.appendChild(b);dopo.parentNode.insertBefore(w,dopo.nextSibling);
  }
  function movimento(root){
    /* feed Instagram: niente bottone «Ferma le foto» (tolto il 5/10 su richiesta); con «riduci movimento» il carosello parte fermo */
    if(RM)root.querySelectorAll('.gfa-carousel__viewport--with-autoplay').forEach(function(vp){
      if(vp._a11y)return;var tr=vp.querySelector('.gfa-carousel__track');if(!tr)return;vp._a11y=1;
      var box=vp.closest('.gfa-carousel')||vp;tr.style.setProperty('--e-fz',tr.style.transform||'none');box.classList.add('e-a11y-ferma');
    });
    if(RM)return;
    var NASTRO=[['.e-marq','',1],['.e-bmus__m','e-a11y-pausa--sx',0]];
    NASTRO.forEach(function(n){
      root.querySelectorAll(n[0]).forEach(function(m){
        if(m._a11y)return;m._a11y=1;
        var b=bottone(n[1],T('Ferma il nastro','Pause the strip'),T('Fai scorrere il nastro','Play the strip'),T('dei loghi','of logos'));
        b.addEventListener('click',function(){var on=!m.classList.contains('e-a11y-ferma');m.classList.toggle('e-a11y-ferma',on);b._set(on)});
        metti(b,m,n[2]);
      });
    });
    root.querySelectorAll('[data-e-ann]').forEach(function(a){
      if(a._a11y||a.querySelectorAll('.e-ann__m').length<2)return;a._a11y=1;
      var fermo=false,b=bottone('e-a11y-pausa--ann',T('Ferma','Pause'),T('Riprendi','Play'),T('i messaggi','the messages'));
      b.addEventListener('click',function(){fermo=!fermo;b._set(fermo);if(fermo&&a._stop)a._stop();else if(!fermo&&!a.matches(':hover')&&!a.contains(document.activeElement))a.dispatchEvent(new Event('mouseleave'))});
      /* il tema riparte all'uscita del mouse o del focus: se è fermo, resta fermo */
      ['mouseleave','focusout'].forEach(function(ev){a.addEventListener(ev,function(){if(fermo&&a._stop)setTimeout(a._stop,0)})});
      a.classList.add('e-a11y-ann');a.appendChild(b);
    });
  }

  /* 7 · giro A2 · menu su computer: il Tab dal bottone aperto entra nel suo pannello e dall'ultima voce passa alla voce dopo (2.4.3) */
  function visibile(e){var r=e.getBoundingClientRect(),s=getComputedStyle(e);return r.width>0&&r.height>0&&s.visibility!=='hidden'}
  function voci(p){return Array.prototype.filter.call(p.querySelectorAll('a[href],button:not([disabled]),input:not([type=hidden]),select,textarea,[tabindex]:not([tabindex="-1"])'),visibile)}
  function menu(){
    var nav=document.querySelector('.e-hd__nav');if(!nav)return;
    var bts=Array.prototype.slice.call(nav.querySelectorAll('button[aria-controls]'));
    document.addEventListener('keydown',function(ev){
      if(ev.key!=='Tab'||ev.altKey||ev.ctrlKey||ev.metaKey)return;
      var a=document.activeElement;
      var i=bts.indexOf(a);
      if(i>=0&&!ev.shiftKey&&a.getAttribute('aria-expanded')==='true'){
        var p=document.getElementById(a.getAttribute('aria-controls'));var v=p&&voci(p);
        if(v&&v.length){ev.preventDefault();v[0].focus()}
        return;
      }
      for(var k=0;k<bts.length;k++){
        var b=bts[k];if(b.getAttribute('aria-expanded')!=='true')continue;
        var pp=document.getElementById(b.getAttribute('aria-controls'));if(!pp||!pp.contains(a))continue;
        var vv=voci(pp);if(!vv.length)return;
        if(ev.shiftKey&&a===vv[0]){ev.preventDefault();b.focus();return}
        if(!ev.shiftKey&&a===vv[vv.length-1]){
          var dopo=bts[k+1];
          if(!dopo){var tutti=voci(document.querySelector('.e-hd')||document.body);var j=tutti.indexOf(b);for(var x=j+1;x<tutti.length;x++){if(!pp.contains(tutti[x])&&bts.indexOf(tutti[x])<0){dopo=tutti[x];break}}}
          if(dopo){ev.preventDefault();if(b.getAttribute('aria-expanded')==='true')b.click();dopo.focus()}
          return;
        }
      }
    },true);
  }

  function tutto(root){try{alt(root);aria(root);errori(root);movimento(root)}catch(e){}}
  function avvio(){
    tutto(document);galleria();try{menu()}catch(e){}
    var t;window.addEventListener('resize',function(){clearTimeout(t);t=setTimeout(galleria,200)});
    if('MutationObserver' in window){
      new MutationObserver(function(ms){
        for(var i=0;i<ms.length;i++){for(var j=0;j<ms[i].addedNodes.length;j++){var n=ms[i].addedNodes[j];if(n.nodeType===1)tutto(n.parentNode||n)}}
      }).observe(document.body,{childList:true,subtree:true});
    }
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',avvio);else avvio();
})();
